import { Module } from 'vuex'
import { RootState } from '../../../../store/state_models'
import { LocationNumbersStoreModule } from '../../types/LocationNumbers'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import state from './state'


export const locationNumbers: Module<LocationNumbersStoreModule, RootState> = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
